module.exports = __webpack_public_path__ + "img/category-note.6455b634.png";